import YandexMap from 'components/kurort-map-modal-yandex';
import {
    lazyLoadBlock,
} from 'methods/utils';

let $map = document.querySelector('.js-map');
lazyLoadBlock($map, loadMap);
function loadMap() {
    let $mapPreloader = document.querySelector('.js-mapPreloader');
    if (!$mapPreloader) {
        return;
    }

    let yandexMap = new YandexMap($map, {
        latitude: $map.dataset.latitude,
        longitude: $map.dataset.longitude,
        zoom: $map.dataset.zoom,
    });

    setTimeout(() => {
        yandexMap.whenInitialized(() => {
            loadHotels(yandexMap);

            yandexMap.removeControlls();
            yandexMap.disableBehaviors();

            $mapPreloader.animate([
                {opacity: 1},
                {opacity: 0},
            ], 300).finished.then(() => {
                $mapPreloader.remove();
            });
        });
    }, 250);
}

function loadHotels(yandexMap) {
    let $mapData = document.getElementById('map-data');
    if (!$mapData) {
        return false;
    }

    let placemarks = JSON.parse(document.getElementById('map-data').textContent);
    if (!placemarks || !placemarks.regionHotel || placemarks.regionHotel.length === 0) {
        return false;
    }

    // добавляем placemarks на карту
    yandexMap.setPlacemarks(placemarks);

    // получаем первый placemark
    let placemark = yandexMap.getCollectionPlacemarks('regionHotel')[placemarks.regionHotel.length - 1];
    if (!placemark) {
        return false;
    }

    // выравниваем по коллекции
    yandexMap.centerByCollection('regionHotel').then(() => {
        // открываем балун
        placemark.balloon.open();

        // выравниваем балун
        setTimeout(() => {
            placemark.balloon.autoPan();
        }, 250);
    });
}